// v3.17.1 — Panier Famille : carte de partage du lien de paiement diaspora
// (rendue dans le chat AYA et dans le CartDrawer).
import { useState } from "react";

export default function FamilyBasketShareCard({ data }) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${data.share_path}`;
  const waText = encodeURIComponent(
    `💛 AYA Panier Famille — j'ai préparé un panier de ${Number(data.total_fcfa || 0).toLocaleString("fr-FR")} FCFA à Abidjan et je compte sur toi pour le payer. Tu ouvres le lien, tu paies en 1 clic (carte ou wallet AYA) et AYA me livre : ${url}`
  );
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (_) { /* clipboard indisponible */ }
  };
  return (
    <div
      data-testid="family-basket-share-card"
      style={{
        marginTop: 10, padding: 14, borderRadius: 14, maxWidth: 440,
        background: "linear-gradient(135deg, rgba(239,199,94,0.10), rgba(16,185,129,0.08))",
        border: "1px solid rgba(239,199,94,0.45)",
      }}
    >
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.4, color: "#EFC75E", marginBottom: 6 }}>
        💛 PANIER FAMILLE · {Number(data.total_fcfa || 0).toLocaleString("fr-FR")} FCFA
      </div>
      <div
        data-testid="family-basket-share-link"
        style={{
          fontFamily: "ui-monospace, Menlo, monospace", fontSize: 11.5,
          padding: "8px 10px", borderRadius: 8, background: "rgba(0,0,0,0.25)",
          border: "1px solid rgba(255,255,255,0.12)", wordBreak: "break-all", marginBottom: 10,
        }}
      >{url}</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <a
          data-testid="family-basket-share-whatsapp"
          href={`https://wa.me/?text=${waText}`}
          target="_blank"
          rel="noreferrer"
          style={{
            flex: 1, minWidth: 160, textAlign: "center", textDecoration: "none",
            padding: "10px 12px", borderRadius: 999, background: "#25D366",
            color: "#062A1F", fontWeight: 800, fontSize: 13,
          }}
        >📲 Partager sur WhatsApp</a>
        <button
          data-testid="family-basket-copy-link"
          onClick={copy}
          style={{
            padding: "10px 14px", borderRadius: 999, background: "transparent",
            color: "#EFC75E", border: "1px solid rgba(239,199,94,0.5)",
            fontWeight: 700, fontSize: 12.5, cursor: "pointer",
          }}
        >{copied ? "✓ Copié" : "📋 Copier"}</button>
      </div>
      <div style={{ fontSize: 11, opacity: 0.6, marginTop: 8 }}>
        Ton proche paie à distance 🌍 — la livraison part chez toi à Abidjan dès le paiement.
      </div>
    </div>
  );
}
